import { render, staticRenderFns } from "./basic.vue?vue&type=template&id=0967ebe6&scoped=true"
import script from "./basic.vue?vue&type=script&setup=true&lang=js"
export * from "./basic.vue?vue&type=script&setup=true&lang=js"
import style0 from "./basic.vue?vue&type=style&index=0&id=0967ebe6&prod&lang=less"
import style1 from "./basic.vue?vue&type=style&index=1&id=0967ebe6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0967ebe6",
  null
  
)

export default component.exports